import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'live' | 'draft' | 'warning' | 'danger' | 'info';

const tones: Record<Tone, string> = {
  neutral: 'bg-zinc-800 text-zinc-300 border-zinc-700',
  live:    'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  draft:   'bg-zinc-700/40 text-zinc-300 border-zinc-600',
  warning: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  danger:  'bg-red-500/15 text-red-300 border-red-500/30',
  info:    'bg-cyan-500/15 text-cyan-300 border-cyan-500/30',
};

export function Badge({ tone = 'neutral', className, children, ...rest }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium uppercase tracking-wide',
        tones[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
